'use strict';

import BaseService from './base.service';

class OperationsService extends BaseService {
  /* @ngInject */
  constructor(Operation, SegaUser) {
    super(Operation, SegaUser);
  }

  createNew(opts) {
    return this.Model.createNew(opts).$promise;
  }

  addProcedure(opts) {
    return this.Model.addProcedure(opts).$promise;
  }

  removeProcedure(opts) {
    return this.Model.removeProcedure(opts).$promise;
  }

  downloadExcel(opts) {
    delete opts.limit;
    delete opts.page;

    return this.Model.excelExport({ filter: opts }).$promise.then(res => {
      return res.body;
    });
  }
}

export default OperationsService;
